<template>
  <div class="confirm-phone-popup__wrapper">
    <base-popup class="confirm-phone-popup" ref="popup" :without-icon="true">
      <template #header="{ close }">
        <div class="confirm-phone-popup__header">
          <div class="confirm-phone-popup__title">
            {{ $t('bills.popup.confirm-phone-popup.title') }}
          </div>
          <popup-close-button
            class="confirm-phone-popup__close"
            @click="close"
          ></popup-close-button>
        </div>
      </template>
      <template #content>
        <div class="confirm-phone-popup__content">
          <text-input
            v-model:value="phone"
            :mask="'38NNNNNNNNNN'"
            title="Телефон"
          />
        </div>
      </template>
      <template #actions>
        <div class="confirm-phone-popup__actions">
          <primary-button
            :label="$t('bills.popup.confirm-phone-popup.title')"
            @click="confirmEmail"
          />
        </div>
      </template>
    </base-popup>
  </div>
</template>

<script>
import BasePopup from '@vue-app/components/base/popup/BasePopup.vue'
import PopupCloseButton from '@vue-app/components/base/button/PopupCloseButton.vue'
import SocialShareButtons from '@vue-app/components/base/share/SocialShareButtons.vue'
import LinkInput from '@vue-app/components/base/input/LinkInput.vue'
import SuccessNotification from '@vue-app/components/base/popup/notification/SuccessNotification.vue'
import TextInput from '@vue-app/components/base/input/TextInput.vue'
import PrimaryButton from '@vue-app/components/base/button/PrimaryButton.vue'

export default {
  name: 'ConfirmPhonePopup',
  components: {
    PrimaryButton,
    TextInput,
    SuccessNotification,
    LinkInput,
    SocialShareButtons,
    PopupCloseButton,
    BasePopup,
  },
  props: {
    template: Object,
  },

  data() {
    return {
      phone: '',
    }
  },
  methods: {
    open(phone) {
      this.phone = phone
      return this.$refs.popup.open()
    },
    async confirmEmail() {
      this.$refs.popup.confirm(this.phone)
    },
  },
}
</script>

<style lang="scss" scoped>
.confirm-phone-popup {
  :deep(.popup) {
    width: 395px;
    padding: 30px 0 52px;
  }

  &__header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 30px;
    height: 30px;
    margin-bottom: 44px;
  }

  &__title {
    font-weight: 600;
    font-size: 16px;
    line-height: 18px;
    color: #585f6d;
  }

  &__close {
    position: absolute;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
  }

  &__content,
  &__actions {
    padding: 0 50px;
  }

  &__input {
    margin-top: 60px;
    padding: 0 52px;
  }
}
</style>
